import { ProfileEmailDialog } from './profile-email-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PROFILE_EMAIL, {
  component: ProfileEmailDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'portal',
});
